import { render, staticRenderFns } from "./VideoContentFeedItem.vue?vue&type=template&id=dd4a0c66&scoped=true"
import script from "./VideoContentFeedItem.vue?vue&type=script&lang=js"
export * from "./VideoContentFeedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4a0c66",
  null
  
)

export default component.exports